import { SHAREABLE_REPORTS_ROUTE } from "Constants";

/* This file contains shared utils between baseApi and Axios.
 * It should be kept pure and not import from Services to avoid circular dependencies
 * */

export const documentCookieAsObject = (
  cookie: string,
): Record<string, string> => {
  /**
   * turn document cookie string into an object
   * example:
   *
   * document.cookie = "someCookie=abcdefghij; csrftoken=123456abcdef; someOtherCookie: xyz"
   *
   * output = {
   *    someCookie: abcdefghij,
   *    csrftoken: 123456abcdef,
   *    someOtherCookie: xyz
   * }
   */
  return cookie
    .split(";")
    .map((singleCookie: string) => {
      return singleCookie.trim().split("=");
    })
    .reduce((result: Record<string, string>, nameAndValue: string[]) => {
      result[nameAndValue[0]] = nameAndValue[1];
      return result;
    }, {});
};

export const getValueFromCookie = (key: string): string => {
  const allCookies = documentCookieAsObject(document.cookie);

  if (Object.prototype.hasOwnProperty.call(allCookies, key))
    return allCookies[key];
  else return "";
};

export const getCsrfToken = (): string => {
  return getValueFromCookie("csrftoken");
};

export const getSharedToken = (): string => {
  const token = window.location.pathname
    .split(`${SHAREABLE_REPORTS_ROUTE}/`)[1]
    .split("/")[0];
  return token;
};
